import axios from "axios";

const ctrl = {};

ctrl.getInfo = async (cedularuc) => {
  return axios.get("/api/patente/persona", {
    params: {
      cedularuc,
    },
  });
};

ctrl.getActividades = async (filtro) => {
  return axios.get("/api/patente/ciiu", {
    params: {
      filtro,
    },
  });
};

ctrl.get = async (cedulaRuc, captchaToken = null) => {
  return axios.get("/api/patente", {
    params: {
      cedulaRuc,
    },
    headers: {
      "X-Altcha-Token": captchaToken || "",
    },
  });
};

ctrl.getContribuyente = async (cedularuc, idpersona) => {
  return axios.get("/api/patente/contribuyente", {
    params: {
      cedularuc,
      idpersona,
    },
  });
};

ctrl.getDeclaraciones = async (cedularuc, idpersona) => {
  return axios.get("/api/patente/declaraciones", {
    params: {
      cedularuc,
      idpersona,
    },
  });
};


ctrl.guardar = async (data) => {
  return axios.post("/api/patente/declaraciones", { ...data });
};

ctrl.imprimir = async (iddeclaracion) => {
  return axios.get("/api/patente/declaraciones/gad/imprimir", {
    params: {
      iddeclaracion,
    },
  });
};

ctrl.getInversiones = async (anio, idpersona) => {
  return axios.get("/api/patente/inversiones", {
    params: {
      anio,
      idpersona,
    },
  });
};

export default ctrl;
